import { Component, OnInit, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Ticket } from '@app/modules/model/ticket';
import { TicketExtra } from '@app/modules/model/ticketextra';

import { languageSupport, languageService } from '@app/modules/common/language'
import { dataService } from '@app/modules/data';
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-cart-extra',
    templateUrl:'./ui-cart.html',
    styleUrls: [ 
        './ui-cart.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiCartExtra extends languageSupport implements OnInit, OnDestroy {
    @Input('ticket') _ticket: Ticket = null;
    @Input('extra') _extra: TicketExtra = null;

    private _subscriptions = [];

    /***********************************/
    /* DATA COMPONENTS                 */
    /***********************************/

    get CanAdd() {
        return this.data.session.user && this._extra.status != 'AC';
    }

    get CanDel() {
        return this.data.session.user && this._extra.status == 'AC';
    }

    /***********************************/
    /* STARTS HERE                     */
    /***********************************/

    constructor(private lang: languageService, private change: ChangeDetectorRef, private data: dataService, public view: viewService) {
        super(lang, change);
    }

    ngOnInit(){
        this._subscriptions.push(
            this.view.OnTheme.subscribe(
            data => {
                this.change.markForCheck();
            })
        );  

        this._subscriptions.push(
            this._ticket.OnRefresh.subscribe(
            data => {
                this.change.markForCheck();
            })
        );    
    }

    ngOnDestroy(){
        super.OnDestroy();

        for(let _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];
    }

    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/

    AddExtra(){
        this._extra.status = 'AC';
        this._ticket.DoUpdate();
    }

    DelExtra(){
        this._extra.status = 'UN';
        this._ticket.DoUpdate();
    }
}
